import React from 'react';
import { useNavigate } from 'react-router-dom';
import theme from '../../theme';

const OVERALL = {
  COMPLETED: ['Check complete', '#065F46', '#ECFDF5'],
  PARTIAL: ['Partly complete — some checks failed', '#92400E', '#FFFBEB'],
  FAILED: ["Check failed — ownership couldn't be confirmed either way", '#991B1B', '#FEF2F2'],
  NOT_APPLICABLE: ['Nothing to check on-chain', '#1E40AF', '#EFF6FF'],
  NO_WALLET: ['No wallet to check', '#5B6472', '#F3F4F6'],
};
const fmt = (iso) => (iso ? new Date(iso).toLocaleString() : '—');

export default function WalletSyncResult({ sync }) {
  const navigate = useNavigate();
  if (!sync) return <div data-testid="wallet-sync-none" style={{ fontSize: 12, color: theme.colors.text.muted, marginTop: 8 }}>Not checked yet.</div>;
  const all = sync.results || [];
  const checked = all.filter(r => r.status !== 'no_contract');
  const noContract = all.filter(r => r.status === 'no_contract');
  const [label, color, bg] = OVERALL[sync.status] || [sync.status, '#5B6472', '#F3F4F6'];
  const found = sync.verified_nfts_found || 0;
  return (
    <div data-testid="wallet-sync-result" style={{ marginTop: 10, padding: 14, borderRadius: 10, background: bg, fontSize: 13 }}>
      <div data-testid="wallet-sync-status" style={{ fontWeight: 800, color }}>{label}</div>
      <div style={{ color: theme.colors.text.secondary, marginTop: 4 }}>
        Checked {fmt(sync.finished_at)} · {sync.wallets} wallet(s) · {sync.contracts_checked ?? checked.length} NFT contract(s) checked
        {sync.checks_failed ? ` · ${sync.checks_failed} failed` : ''} · <b data-testid="wallet-sync-found">{found} verified NFT(s) found</b>
      </div>
      <div style={{ color: theme.colors.text.muted, fontSize: 12, marginTop: 2 }}>Last successful check: {fmt(sync.last_successful_at)}</div>
      {sync.unverified_nfts_seen > 0 && <div style={{ fontSize: 12, color: '#92400E', marginTop: 4 }}>{sync.unverified_nfts_seen} NFT(s) seen in unverified wallets — verify the wallet for them to count.</div>}
      {noContract.length > 0 && (
        <div data-testid="wallet-sync-no-contract" style={{ fontSize: 12, color: theme.colors.text.muted, marginTop: 6 }}>
          Not applicable: {noContract.length} Kickback(s) have no deployed NFT contract, so there's nothing on-chain to check ({noContract.map(r => r.portfolio_name || 'Kickback').join(', ')}). This is not a failed check.
        </div>
      )}
      {checked.map((r, i) => (
        <div key={i} data-testid={`wallet-sync-row-${i}`} style={{ padding: '6px 0', borderTop: '1px solid rgba(0,0,0,0.06)', marginTop: 6 }}>
          <b>{r.portfolio_name || 'Kickback'}</b>
          {r.chain_label && <span style={{ color: theme.colors.text.muted }}> · {r.chain_label} · {r.standard}</span>}
          {r.wallet && <span style={{ color: theme.colors.text.muted }}> · {r.wallet.slice(0, 8)}…{r.wallet_verified ? '' : ' (unverified)'}</span>}
          <div style={{ color: r.status === 'ok' ? theme.colors.text.secondary : '#991B1B' }}>
            {r.status === 'ok'
              ? ((r.tokens || []).length ? `Holds ${r.tokens.map(t => (t.token_id != null ? `#${t.token_id}` : 'tokens') + ` ×${t.balance}`).join(', ')}` : 'Confirmed: no NFTs from this Kickback in this wallet')
              : `${r.message} Ownership is unconfirmed — not treated as zero.`}
          </div>
        </div>
      ))}
      <div style={{ marginTop: 8, fontSize: 12, color: theme.colors.text.secondary }}>
        {found > 0
          ? <button data-testid="wallet-sync-view-nfts" onClick={() => navigate('/buyer/dashboard')} style={{ background: 'none', border: 'none', color: theme.colors.primary, fontWeight: 700, cursor: 'pointer', padding: 0 }}>View your NFT records →</button>
          : "No verified NFTs doesn't affect your claims — account-based benefits still work without an NFT."}
        {sync.status === 'FAILED' || sync.status === 'PARTIAL' ? ' Try the check again in a minute.' : ''}
      </div>
    </div>
  );
}
